import { useState } from "react";
import { ModuleHeader } from "../../../shared/components/ModuleHeader";
import { FilesIcon } from "../../../shared/components/icons";
import { OneDrivePanel } from "../onedrive/components/OneDrivePanel";
import { SharePointPanel } from "../sharepoint/components/SharePointPanel";
import styles from "./FilesModule.module.css";

type FilesTab = "onedrive" | "sharepoint";

interface FilesModuleProps {
  readonly graphToken: string | null;
  readonly onBack?: () => void;
}

export function FilesModule({ graphToken, onBack }: Readonly<FilesModuleProps>) {
  const [activeTab, setActiveTab] = useState<FilesTab>("onedrive");

  return (
    <div className={styles.module}>
      <ModuleHeader
        title="Document Management"
        subtitle="OneDrive & SharePoint"
        icon={FilesIcon}
        accent="files"
        onBack={onBack}
      />

      <div className={styles.tabs} role="tablist" aria-label="Files source">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "onedrive"}
          className={`${styles.tab} ${activeTab === "onedrive" ? styles.tabActive : ""}`}
          onClick={() => setActiveTab("onedrive")}
        >
          OneDrive
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "sharepoint"}
          className={`${styles.tab} ${activeTab === "sharepoint" ? styles.tabActive : ""}`}
          onClick={() => setActiveTab("sharepoint")}
        >
          SharePoint
        </button>
      </div>

      {activeTab === "onedrive" && <OneDrivePanel graphToken={graphToken} />}
      {activeTab === "sharepoint" && <SharePointPanel graphToken={graphToken} />}
    </div>
  );
}
